import React from 'react'
import styles from './IconTextDescriptionItem.module.sass'
import { MenuItemType } from '@next-nx/utils/types'
import { getIcon } from '@next-nx/utils/icons'

interface Props {
  className?: string
  item?: MenuItemType
  useIconIdVariant?: boolean
}

const IconTextDescriptionItem = (props: Props) => {
  const { className = '', item = undefined, useIconIdVariant = false } = props

  return (
    <div className={`${styles.root} ${className}`}>
      {!!getIcon(item?.style) && !useIconIdVariant && (
        <div className={styles.icon}>{getIcon(item?.style)}</div>
      )}
      {!!getIcon(item?.style) && useIconIdVariant && (
        <div className={styles.icon}>{getIcon(item?.style, item?.pk?.toString())}</div>
      )}
      <div className={styles.content}>
        {!!item?.name && <div className={styles.nome}>{item?.name}</div>}
        {!!item?.description && <div className={styles.descrizione}>{item?.description}</div>}
        {!!item?.descriptionHtml && !item.description && (
          <div
            className={styles.descrizione}
            dangerouslySetInnerHTML={{ __html: item.descriptionHtml }}
          />
        )}
      </div>
    </div>
  )
}

export default IconTextDescriptionItem
